import React, { useEffect, useMemo, useState } from "react";
import { status } from "../../core/common/selectoption/selectoption";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store.js";
import { Drawer, message } from "antd";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../core/common/GlobalFunctions/exportTableData";
import { createTicketCategory, deleteTicketCategory, fetchTicketAllCategories, updateTicketCategory, } from "../../core/data/redux/tickets/ticketCategoryActions";
import { TicketCategoryErrorMessages } from "./ticketsErrorMessage";
import { decryptData } from "../../core/utils/encryptUtils";
import dayjs from "dayjs";

const TickitsCategory = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const { TicketsCategories, loading } = useSelector((state: any) => state.ticket.ticketCategory);
  const [errors, setErrors] = useState<any>({});
  const [assetCategory, setAssetCategory] = useState({
    category_name: "",
    status: "",
  });
  const [errorMessages, setErrorMessages] = useState({
    categoryName: "",
    status: "",
  });

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  const resetForm = () => {
    setAssetCategory({
      category_name: "",
      status: "",
    });
    setErrorMessages({
      categoryName: "",
      status: "",
    });
  };

  useEffect(() => {
    if (!TicketsCategories?.length) {
      dispatch(fetchTicketAllCategories());
    }
  }, [dispatch]);

  const handleInputChange = (e: any, field: string) => {
    const { value } = e.target;
    setAssetCategory((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetForm();
  };
  const handleEditTicketCategory = (record: any): void => {
    setSelectedRowData(record);
    setAssetCategory({
      category_name: record.category_name,
      status: record.status,
    });
    showModal("edit");
  };

  const handleSubmit = async () => {
    const newErrorMessages = { categoryName: "", status: "" };
    let hasError = false;

    if (!assetCategory.category_name.trim()) {
      newErrorMessages.categoryName =
        TicketCategoryErrorMessages.CategoryNameRequired;
      hasError = true;
    }
    if (!assetCategory.status) {
      newErrorMessages.status = TicketCategoryErrorMessages.StatusRequired;
      hasError = true;
    }

    if (hasError) {
      setErrorMessages(newErrorMessages);
      return;
    }

    const data = {
      ...assetCategory,
      created_by: modalType === "create" ? user.UserId : undefined,
      modified_by: modalType === "edit" ? user.UserId : undefined,
    };

    try {
      let result;
      if (modalType === "create") {
        result = await dispatch(createTicketCategory(data)).unwrap();
      } else if (modalType === "edit") {
        if (selectedRowData) {
          result = await dispatch(
            updateTicketCategory({
              categoryId: selectedRowData.ticket_category_id,
              ...data,
            })
          ).unwrap();
        }
      }
      if (result) {
        message.success(result.message);
        await dispatch(fetchTicketAllCategories());
        setTableKey((prevKey) => prevKey + 1);
        resetForm();
      } else {
        message.error(TicketCategoryErrorMessages.GenericError);
      }
      handleCancel();
    } catch (error: any) {
      const errorMessage = error?.error || TicketCategoryErrorMessages.GenericError;
      message.error(errorMessage);
    }
  };

  const handleDeleteTicketCategory = async (categoryId: number) => {
    try {
      const result = await dispatch(deleteTicketCategory(categoryId)).unwrap();
      if (result) {
        message.success(result.message);
        await dispatch(fetchTicketAllCategories());
        setTableKey((prevKey) => prevKey + 1);
        setIsDeleteModalVisible(false);
      }
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = TicketsCategories ? TicketsCategories : [];

  const exportTicketCategory = data.map((item: any) => ({
    "Ticket Category Name": item.category_name,
    Status: item.status,
    CreatedAt: item.created_at ? dayjs(item.created_at).format("YYYY-MM-DD") : null,
    ModifiedAt: item.modified_at ? dayjs(item.modified_at).format("YYYY-MM-DD") : null,
    // ModifiedBy: item.modified_by,
    // CreatedBy: item.created_by,
  }))


  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "created_at",
      "created_at",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, data]);
  const columns = [
    {
      title: "Ticket Category Name",
      dataIndex: "category_name",
      render: (text: String) => <h6 className="fs-14 fw-medium">{text}</h6>,
      sorter: (a: any, b: any) => a.category_name.length - b.category_name.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <>
          <span
            className={`badge d-inline-flex align-items-center badge-xs ${text === "active"
              ? "badge-success"
              : text === "inactive"
                ? "badge-danger"
                : "badge-warning"
              }`}
          >
            <i className="ti ti-point-filled me-1"></i>
            {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

          </span>
        </>
      )
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isInactive = record.status === "inactive";
        const isDeleteDisabled = !canDelete || isInactive;

        return (
          <div className="action-icon d-inline-flex">
            {/* Edit Button */}
            <button
              className="me-2"
              onClick={() => {
                if (!canEdit) return;
                showModal("edit");
                handleEditTicketCategory(record);
              }}
              disabled={!canEdit}
              style={{
                cursor: canEdit ? "pointer" : "not-allowed",
                opacity: canEdit ? 1 : 0.5,
              }}
              title={!canEdit ? "Permission Denied" : "Edit Ticket Category"}
            >
              <i className="ti ti-edit" />
            </button>

            {/* Delete Button */}
            <button
              onClick={() => {
                if (!canDelete || record.status === "inactive") return;
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
              disabled={isDeleteDisabled}
              className="me-2"
              style={{
                cursor: isDeleteDisabled ? "not-allowed" : "pointer",
                opacity: isDeleteDisabled ? 0.5 : 1,
              }}
              title={
                !canDelete
                  ? "Permission Denied"
                  : isInactive
                    ? "Inactive - Cannot Delete"
                    : "Delete Ticket Category"
              }
            >
              <i className="ti ti-trash" />
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Tickets Category</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Ticket</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Tickets Category
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportTicketCategory, "Ticket_category")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportTicketCategory, "Ticket_category")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToPDF(exportTicketCategory, "Ticket_category")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as PDF{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button
                    onClick={() => showModal("create")}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add New Category
                  </button>
                </div>
              )}
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Assets Lists */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Ticket Category List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Assets */}
      <Drawer title={modalType === "edit" ? "Edit Ticket Category" : "Add Ticket Category"}
        placement="right"
        width={400}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50 }}
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Category Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={assetCategory.category_name}
                    onChange={(e) => handleInputChange(e, "category_name")}
                  />
                  {errorMessages.categoryName && (
                    <div className="text-danger">
                      {errorMessages.categoryName}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3 ">
                  <label className="form-label">
                    Status <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={assetCategory.status}
                    onChange={(e) => handleInputChange(e, "status")}
                  >
                    {status.map((status: any) => (
                      <option key={status.value} value={status.value}>
                        {status.label}
                      </option>
                    ))}
                  </select>
                  {errorMessages.status && (
                    <div className="text-danger">{errorMessages.status}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {modalType === "edit" ? "Update Category" : "Add Category"}
            </button>
          </div>
        </form>
      </Drawer>
      {/* /Add Assets */}
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.ticket_category_id &&
          handleDeleteTicketCategory(selectedRowData.ticket_category_id)
        }
      />
    </>
  );
};

export default TickitsCategory;
